import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const reports: ThemeUICSSObject = {
  /* PREPEND HERE */
  upsertion: {
    form: {
      display: 'grid',
      gap: 4,
    },
    '.export_container': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      gap: '10px',
      span: {
        ul: {
          display: 'flex',
        },
      },
    },
    '.reportData_container': {
      gap: 2,
      display: 'flex',
      flexDirection: 'column',
      '.reportData_details': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'start',
      },
    },
    '.name_container, .export_container': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'start',
      flexDirection: 'row',
      gap: '10px',
    },
    '.radio': {
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
    },
    '.table_container': {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
  },

  '&.aside__container': {
    '.asidePanel': {
      '.asidePanel__content': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },
};

export default reports;
